import React from 'react';
import View from '@src/components/view';
import preloadImages from '@src/utils/preload-images';
import { withoutProps } from '@src/utils/data-utils';

const styles = require('./index.less');
/**
 * 是否准备好, 静态全局缓存值
 * @type {boolean}
 */
let isReady = false;

/**
 * 路由 loading 加载中的图片
 */
export default class RouteLoadingImage extends React.PureComponent {
  componentDidMount() {
    const { onReady } = this.props;
    if (!isReady) {
      preloadImages(this.getPreloadList(), { shouldConvert2Webp: false })
        .then(() => {
          isReady = true;
        })
        .finally(() => !this.isUnmount && onReady())
        .catch(f => f);
    } else {
      onReady();
    }
  }

  static LOADING_IMAGE_TYPE = {
    JX3: 'jx3',
    SEASUN_ICON: 'seasunIcon',
    LITTLE_YELLOW_CHICKEN: 'littleYellowChicken',
    SEASUN_TEXT: 'seasunText'
  };

  static defaultProps = {
    loadingImageType: RouteLoadingImage.LOADING_IMAGE_TYPE.JX3
  };

  componentWillUnmount() {
    this.isUnmount = true;
  }

  getLoadingStyle = () => {
    const { loadingImageType } = this.props;
    if (loadingImageType === RouteLoadingImage.LOADING_IMAGE_TYPE.JX3) {
      return styles.jx3Loading;
    } else if (loadingImageType === RouteLoadingImage.LOADING_IMAGE_TYPE.SEASUN_ICON) {
      return styles.seasunLoading;
    } else if (loadingImageType === RouteLoadingImage.LOADING_IMAGE_TYPE.LITTLE_YELLOW_CHICKEN) {
      return styles.littleYellowChicken;
    } else if (loadingImageType === RouteLoadingImage.LOADING_IMAGE_TYPE.SEASUN_TEXT) {
      return styles.seasunTextLoading;
    } else {
      return styles.littleYellowChicken;
    }
  };

  getPreloadList = () => {
    const { loadingImageType } = this.props;
    if (loadingImageType === RouteLoadingImage.LOADING_IMAGE_TYPE.JX3) {
      return ['//zhcdn01.xoyo.com/xassets/lib/zt/m/loading-img/jx3-loading.gif?__WEBP__=1'];
    } else if (loadingImageType === RouteLoadingImage.LOADING_IMAGE_TYPE.SEASUN_ICON) {
      return ['//zhcdn01.xoyo.com/xassets/lib/zt/m/loading-img/seasun-loading.gif?__WEBP__=1'];
    } else if (loadingImageType === RouteLoadingImage.LOADING_IMAGE_TYPE.LITTLE_YELLOW_CHICKEN) {
      return [require('./images/loading.gif')];
    } else if (loadingImageType === RouteLoadingImage.LOADING_IMAGE_TYPE.SEASUN_TEXT) {
      return [];
    } else {
      return [require('./images/loading.gif')];
    }
  };

  render() {
    return <View css={this.getLoadingStyle()} {...withoutProps(this.props, ['onReady', 'loadingImageType'])} />;
  }
}
